import colors from 'style/_colors.scss';

export default (str) => {
    const keys = Object.keys(colors);
    const map = Array.prototype.map;
    let num = 0;

    map.call(str, char => {
        num += char.charCodeAt(0);
    });

    return colors[keys[num % keys.length]];
};
